import styled from 'styled-components';

import { flexCenter } from '../../../style/reusableStyle';

export const AddPrinterContainerStyled = styled.div`
  margin-top: 18px;

  & .title {
    margin-bottom: 10px;
  }

  & .printer-select-wrapper {
    max-width: 600px;
    margin-bottom: 30px;
  }
  & .noPrinterFound {
    ${flexCenter(0)}
  }
`;
